import React, { useEffect, useState } from 'react';
import '../../styles/Profilepage.scss';
import axios from 'axios';
import translations from '../../translate.js';
import backIcon from '../../img/Back.svg';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import reportIcon from '../../img/ReportProblem.svg';

const SettingsPage = () => {
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState({
        firstName: '',
        role: '',
        filterLimit: 0,
        activeFilters: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const [selectedLanguage] = useState(localStorage.getItem('language') || 'en');
    const text = translations[selectedLanguage];

    // ✅ Funkcija, kas nosaka limitu pēc lomas
    const getMaxFilters = (role) => {
        switch (role) {
            case 'basic':
                return 5;
            case 'advanced':
                return 10;
            case 'admin':
                return 20;
            default:
                return 0;
        }
    };

    // API pieprasījumi, lai iegūtu datus
    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("Fetching user information...");

                const userResponse = await axios.get('filters/get/user-info', { withCredentials: true });
                console.log("User data (filters):", userResponse.data);

                if (userResponse.data) {
                    const firstName = userResponse.data.firstName || 'Nav norādīts';

                    const limitsResponse = await axios.get('/filters/get/filter-limit', { withCredentials: true });
                    console.log("Filter limit and user info:", limitsResponse.data);

                    const activeFiltersResponse = await axios.get('/filters/get/combined-count', { withCredentials: true });
                    console.log("Active filters:", activeFiltersResponse.data);

                    setUserInfo({
                        firstName: firstName,
                        role: limitsResponse.data.role || text.noRole,
                        filterLimit: getMaxFilters(limitsResponse.data.role),
                        activeFilters: activeFiltersResponse.data.combinedCount || 0,
                    });
                }
            } catch (error) {
                console.error('Error fetching user info:', error.message);
                setError(text.loadError);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    //Dzēšanas funkcija
    const handleDeleteAccount = async () => {
    setDeleteLoading(true);
    try {
        await axios.delete('/api/user/delete-account', { withCredentials: true });
        alert(text.accountDeleted);

        // Aizver Telegram mini aplikāciju
        if (window.Telegram && window.Telegram.WebApp) {
            window.Telegram.WebApp.close();
        } else {
            navigate('/');
        }
    } catch (error) {
        console.error('Error deleting account:', error.message);
        alert(text.deleteError);
    } finally {
        setDeleteLoading(false);
        setShowModal(false);
    }
};


    if (loading) {
        return <div>{text.loading}</div>;
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div className="settings-page">

            <div className="title-container">
                <img
                    src={backIcon}
                    alt={text.back}
                    className="back-icon"
                    onClick={() => navigate('/main')}
                />
                <h2 className="title">{text.settings}</h2>
            </div>

            <div className="user-info-card">
                <h2>{text.userInfo}</h2>
                <div className="plan-info">
                    <p><strong>{text.firstName}:</strong> {userInfo.firstName}</p>
                    <p><strong>{text.role}:</strong> {userInfo.role}</p>
                </div>
            </div>

            <div className="filter-limit-card"> 
                <h2>{text.filterLimits}</h2>
                <p>{text.yourLimit}: {userInfo.filterLimit}</p>
                <p>{text.activeFilters} {userInfo.activeFilters}</p>
            </div>

            <button className="del-account" onClick={() => setShowModal(true)}>
                {text.deleteAccountTitle}
                <img src={reportIcon} alt="Report a Problem" />
            </button>

           <Modal show={showModal} onHide={() => setShowModal(false)} className="custom-modal">
    <Modal.Header className="justify-content-center">
        <Modal.Title className="modal-title-centered">
            {text.deleteAccountTitle}
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: text.deleteAccountMessage }} />
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
            {text.cancel}
        </Button>
        <Button variant="danger" onClick={handleDeleteAccount} disabled={deleteLoading}>
            {deleteLoading ? text.confirming : text.confirm}
        </Button>
    </Modal.Footer>
</Modal>
        </div>
    );
};

export default SettingsPage;
